module.exports = __webpack_public_path__ + "media/subscription.7690e40.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/subscription.mp4
// module id = 8VZF
// module chunks = 3